export var PhotoType;
(function (PhotoType) {
    PhotoType["BEFORE"] = "before";
    PhotoType["AFTER"] = "after";
    PhotoType["PROGRESS"] = "progress";
})(PhotoType || (PhotoType = {}));
